import { useState } from 'react';
import axios from 'Axios';
import { useLocation, useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useModal, useAuthModal } from 'Hooks';
import { fetchUser, setToken } from 'Actions';
import { toastify, api, currentUser, Names, clx } from 'Utils';
import { Button, FieldMessage, FormMessage } from 'Elements';
import styles from 'partials/login.module.scss';
import modalStyle from 'partials/modalbox/modal-form.module.scss';
import Logo from 'assets/img/icon-logo.svg';

export const Login = () => {
	const initialState = () => ({
		fields: {
			username: '',
			password: ''
		},
		isSubmiting: false,
		modal: 'register',
		errors: {},
		messages: {}
	});

	const [state, setState] = useState(initialState());
	const [openModal, toggleModal] = useModal();
	const DynamicModal = useAuthModal(state.modal);
	const dispatch = useDispatch();
	const location = useLocation();
	const history = useHistory();

	const handleModalChange = (modal_name) => {
		setState((prev) => ({
			...prev,
			modal: modal_name
		}));
		toggleModal();
	};

	const handleCloseModal = () => {
		toggleModal();
	};

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.username) {
			formIsValid = false;
			errors['username'] = 'نام کاربری را وارد کنید';
		}
		if (!fields.password) {
			formIsValid = false;
			errors['password'] = 'کلمه عبور را وارد کنید';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		const data = state.fields;
		if (validateForm()) {
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));

			axios.post(api.login, data).then((res) => {
				let data = res.data;
				setState((prev) => ({
					...prev,
					isSubmiting: false
				}));
				if (res.status === 200) {
					if (data.success) {
						const token = data.result.token;
						currentUser.setToken(token);
						dispatch(setToken(token));
						dispatch(fetchUser());
						history.push(
							location.state?.from || Names.profile.path
						);
					} else {
						setState((prev) => ({
							...prev,
							messages: data.message
						}));
					}
				} else {
					toastify('خطا در برقراری ارتباط با سرور');
				}
			});
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<main className={styles.box}>
			<aside className={styles.imagebox}>
				<img src={Logo} alt="logo" className={styles.logo} />
			</aside>
			<form
				className={clx(modalStyle.form, styles.form)}
				onSubmit={handleSubmit}>
				<div className={styles.body}>
					<header className={clx(modalStyle.header, styles.header)}>
						<h3 className={modalStyle.headerTitle}>ورود</h3>
					</header>
					{Object.keys(state.messages).map((keys, idx) => {
						const [message] = state.messages[keys];
						return <FormMessage key={idx} text={message} />;
					})}
					<div className={modalStyle.fieldset}>
						<label htmlFor="username" className={modalStyle.label}>
							نام کاربری
						</label>
						<input
							id="username"
							name="username"
							type="text"
							className={[
								modalStyle.input,
								modalStyle.input_ltr
							].join(' ')}
							onChange={handleInput}
						/>
						{state.errors.username && (
							<FieldMessage text={state.errors.username} />
						)}
					</div>
					<div className={modalStyle.fieldset}>
						<label htmlFor="password" className={modalStyle.label}>
							کلمه عبور
							<span
								role="button"
								tabIndex="-1"
								onKeyDown={() => handleModalChange('forget')}
								className={modalStyle.labelLink}
								onClick={() => handleModalChange('forget')}>
								کلمه عبور را فراموش کرده اید؟
							</span>
						</label>
						<input
							id="password"
							name="password"
							type="password"
							className={[
								modalStyle.input,
								modalStyle.input_ltr
							].join(' ')}
							onChange={handleInput}
						/>
						{state.errors.password && (
							<FieldMessage text={state.errors.password} />
						)}
					</div>
					<div className={modalStyle.fieldset}>
						<Button
							className={clx(
								modalStyle.submit,
								modalStyle.submitFull
							)}
							disabled={state.isSubmiting}
							type="submit">
							ورود به حساب کاربری
						</Button>
					</div>
					<div className={modalStyle.fieldset}>
						<p className={modalStyle.text}>
							عضو نیستید؟ &nbsp;
							<Button
								className={modalStyle.textLink}
								onClick={() => handleModalChange('register')}>
								ایجاد حساب کاربری
							</Button>
						</p>
					</div>
				</div>
			</form>
			<DynamicModal
				size="sm"
				isOpen={openModal}
				onClose={handleCloseModal}
				onToggleLogin={handleCloseModal}
				onToggleForget={() => handleModalChange('forget')}
				onToggleRegister={() => handleModalChange('register')}
				onTogglePassword={() => handleModalChange('password')}
			/>
		</main>
	);
};
